import { useEffect, useState } from 'react'

/* True when the visitor asked their system for less motion. Starts false so server and first client render agree. */
export const useReducedMotion = (): boolean => {
    const [reduced, setReduced] = useState(false)

    useEffect(() => {
        const query = window.matchMedia('(prefers-reduced-motion: reduce)')
        const update = () => setReduced(query.matches)

        update()
        query.addEventListener('change', update)

        return () => query.removeEventListener('change', update)
    }, [])

    return reduced
}
